import $ from 'jquery'
import selectChoices from './selectChoices'
import debounce from 'debounce'
import Behaviors from '../behaviors'

export default class selectChoicesSchengenGetFlowerOptions extends selectChoices {
    initialize () {
        this.optionsUrl = this.$element.data('optionsUrl')
        this.contentID = this.$element.data('contentId')
        this.$form = this.$select.closest('form')
        this.$content = this.$form.find(`#${this.contentID}`)

        super.initialize()

        this.$select.on('change', this.handleSelctChange.bind(this))
    }

    handleSelctChange (event) {
        const optionsUrl = this.optionsUrl + '?prid=' + encodeURIComponent(this.$select.val())
        this.$form.addClass('submitting')
        $.get(optionsUrl, (data, xhr, status) => { })
            .done((data) => {
                Behaviors.detachBehaviors(this.$content.get(0))
                this.$content.html(data)
                Behaviors.attachBehaviors(this.$content.get(0))

            }).fail(() => {
                console.error('FEHLER!')
            }).always(() => {
                this.$form.removeClass('submitting')
            })
    }
}
